export default __webpack_public_path__ + "static/heroCovidOnlyMobile-1535941dac08a4530c9d1a97766e17db.jpg";